import React from 'react';
import { IMAGES } from '../data';
import { Reveal } from './Reveal';
export function Tonality() {
  return <section className="relative w-full overflow-hidden" data-id="element-152" data-mp="j2i6rapullh5">
      <img src={IMAGES.peopleLaughing} alt="Vänner och familj som skrattar runt ett middagsbord i kvällsljus" className="absolute inset-0 h-full w-full object-cover" data-id="element-153" data-mp="eaqpjqsl0s3o" />
      <div className="absolute inset-0 bg-bourgogne/80" data-id="element-154" data-mp="4ckp7dmfbu0x" />

      <div className="relative z-10 mx-auto max-w-4xl px-6 py-32 text-center text-warm md:py-48 md:px-10" data-id="element-155" data-mp="4e4696fwm93r">
        <Reveal data-id="element-156" data-mp="9ed3pcmr8mj">
          <p className="text-[12px] uppercase tracking-wide3 text-warm/60" data-id="element-157" data-mp="d21ka37x4ue">Tonalitet</p>
        </Reveal>
        <Reveal delay={0.1} data-id="element-158" data-mp="3rj3jn2lloypj">
          <p className="mt-8 font-display text-2xl font-light leading-snug text-warm/50 line-through decoration-1 md:text-3xl" data-id="element-159" data-mp="3mip8hbopd8na">
            Sveriges största cateringportal.
          </p>
        </Reveal>
        <Reveal delay={0.2} data-id="element-160" data-mp="1kqarqfxwaa8g">
          <h2 className="mt-6 font-display text-4xl font-light leading-tight md:text-6xl" data-id="element-161" data-mp="1ks3zxzo5p2ik">
            Smålands bästa smaker.
            <br data-id="element-162" data-mp="7jvsivktdbzr" />
            Noggrant utvalda.
          </h2>
        </Reveal>
        <Reveal delay={0.3} data-id="element-163" data-mp="bkxs5din7q29">
          <p className="mx-auto mt-8 max-w-xl text-lg leading-relaxed text-warm/80" data-id="element-164" data-mp="bh1mwpsta4dx">
            Till människor som uppskattar riktigt bra mat.
          </p>
        </Reveal>
      </div>
    </section>;
}